// Spanish translations
const common = {
  "nav.home": "Inicio",
  "nav.generator": "Generador IA",
  "nav.pricing": "Precios",
  "nav.login": "Iniciar sesión / Registrarse",
  "nav.startFree": "Empezar Gratis",
  "nav.memberCenter": "Centro de Miembros",
  "nav.logout": "Cerrar sesión",

  "hero.badge": "100% Gratis Para Siempre • Sin Registro",
  "hero.title1": "Generador de",
  "hero.title2": "Imágenes IA Gratis",
  "hero.subtitle": "Transforma tus ideas en imágenes impresionantes al instante con IA.\nSin registro, generaciones ilimitadas, completamente gratis.",
  "hero.ctaPrimary": "Empezar Gratis",
  "hero.ctaSecondary": "Ver Cómo Funciona",
  "hero.trust1": "Sin Tarjeta de Crédito",
  "hero.trust2": "Uso Ilimitado",
  "hero.trust3": "Derechos Comerciales",

  "features.badge": "Características",
  "features.title": "Generación de Imágenes IA Potente",
  "features.subtitle": "Experimenta la creación de imágenes IA de próxima generación con funciones de vanguardia",
  "features.f1.title": "Texto a Imagen",
  "features.f1.desc": "Transforma tus palabras en imágenes impresionantes con modelos de IA avanzados.",
  "features.f2.title": "Imagen a Imagen",
  "features.f2.desc": "Sube cualquier imagen y transfórmala en diferentes estilos al instante.",
  "features.f3.title": "Transferencia de Estilo",
  "features.f3.desc": "Aplica estilos artísticos a tus imágenes. Desde realista hasta anime.",
  "features.f4.title": "Ultra Rápido",
  "features.f4.desc": "Genera imágenes de calidad profesional en segundos.",
  "features.f5.title": "Privacidad Protegida",
  "features.f5.desc": "Política de cero retención de datos. Tus prompts e imágenes nunca se almacenan.",
  "features.f6.title": "Ilimitado y Gratis",
  "features.f6.desc": "Sin límites de uso, sin tarjetas de crédito, sin registro requerido.",

  "gallery.badge": "Galería",
  "gallery.title": "Inspírate",
  "gallery.subtitle": "Explora impresionantes imágenes generadas por IA de nuestra comunidad",
  "gallery.cta": "Crea el Tuyo",
  "gallery.clickToUse": "Haz clic para usar",
  "gallery.copyPrompt": "Copiar Prompt",
  "gallery.copied": "¡Copiado!",
  "gallery.usePrompt": "Usar Este",
  "gallery.hoverTip": "Pasa el cursor sobre cualquier imagen para copiar o usar su prompt",

  "stats.title": "Confiado por Millones",
  "stats.subtitle": "Únete a la comunidad de generadores de imágenes IA gratuitos más grande del mundo",
  "stats.s1.label": "Usuarios Activos",
  "stats.s1.value": "3M+",
  "stats.s1.desc": "Usuarios activos mensuales",
  "stats.s2.label": "Imágenes Creadas",
  "stats.s2.value": "1,530",
  "stats.s2.desc": "Imágenes generadas por minuto",
  "stats.s3.label": "Valoración",
  "stats.s3.value": "4.9",
  "stats.s3.desc": "Valoración media de calidad",

  "testimonials.badge": "Testimonios",
  "testimonials.title": "Lo Que Dicen los Creadores",
  "testimonials.subtitle": "Descubre cómo los creadores usan nuestra IA para aumentar la productividad",
  "testimonials.ratings": "Basado en más de 25,017 valoraciones, media 4.9/5 estrellas",
  "testimonials.t1.name": "Sophie Miller",
  "testimonials.t1.role": "Diseñadora Freelance",
  "testimonials.t1.content": "¡Este generador de imágenes IA ha aumentado mi eficiencia creativa 10 veces! La calidad de imagen es increíble.",
  "testimonials.t2.name": "Michael Chen",
  "testimonials.t2.role": "Director Creativo",
  "testimonials.t2.content": "Con las funciones avanzadas, puedo controlar cada detalle con precisión. ¡Es el generador de imágenes IA más potente del mercado!",
  "testimonials.t3.name": "Sarah Wang",
  "testimonials.t3.role": "Gerente de E-commerce",
  "testimonials.t3.content": "Como gerente de e-commerce, esta herramienta me ayuda a generar imágenes de productos rápidamente.",
  "testimonials.t4.name": "David Liu",
  "testimonials.t4.role": "Diseñador de Marca",
  "testimonials.t4.content": "El editor me permite mantener la coherencia del estilo de marca. Este generador realmente entiende mis necesidades.",
  "testimonials.t5.name": "Emma Zhang",
  "testimonials.t5.role": "Creadora de Contenido",
  "testimonials.t5.content": "¡La velocidad es increíble! Imágenes de calidad profesional generadas en segundos.",
  "testimonials.t6.name": "Kevin Wu",
  "testimonials.t6.role": "Artista Conceptual",
  "testimonials.t6.content": "El rendimiento de detalle no tiene rival. Como desarrollador de juegos, esta es nuestra herramienta principal.",

  "cta.title1": "¿Listo para Crear",
  "cta.title2": "Arte IA Increíble?",
  "cta.subtitle": "Únete a millones de creadores que usan el generador de imágenes IA gratuito más potente del mundo",
  "cta.button": "Genera Tu Primera Imagen Gratis",
  "cta.note": "Sin tarjeta de crédito • Sin registro • Generaciones ilimitadas",

  "faq.badge": "FAQ",
  "faq.title": "Preguntas Frecuentes",
  "faq.contact": "¿Más preguntas? Contáctanos en support@aiimagegenrator.com",
  "faq.q1": "¿Qué es este Generador de Imágenes IA y cómo funciona?",
  "faq.a1": "Nuestro Generador de Imágenes IA es la primera herramienta completamente gratuita e ilimitada del mundo para crear imágenes con IA.",
  "faq.q2": "¿Es realmente gratis usar este Generador de Imágenes IA?",
  "faq.a2": "¡Sí, es completamente gratis! Sin tarifas ocultas, sin tarjetas de crédito y sin límites de uso.",
  "faq.q3": "¿Qué lo diferencia de otros generadores de imágenes IA?",
  "faq.a3": "Somos la única plataforma que ofrece uso gratuito ilimitado con enrutamiento inteligente entre múltiples modelos de IA.",
  "faq.q4": "¿Necesito crear una cuenta para usarlo?",
  "faq.a4": "¡No se necesita cuenta! Puedes visitar y empezar a generar imágenes de inmediato.",
  "faq.q5": "¿Qué tipos de imágenes puedo crear?",
  "faq.a5": "Puedes crear escenas realistas, ilustraciones artísticas, arte digital, imágenes estilo anime y mucho más.",
  "faq.q6": "¿Cómo protege mi privacidad?",
  "faq.a6": "No almacenamos tus prompts ni imágenes generadas en nuestros servidores.",
  "faq.q7": "¿Puedo usar las imágenes generadas con fines comerciales?",
  "faq.a7": "Sí, eres propietario de los derechos de las imágenes generadas. Puedes usarlas para fines personales y comerciales.",
  "faq.q8": "¿Está disponible en dispositivos móviles?",
  "faq.a8": "Actualmente puedes acceder a través de nuestro sitio web, que funciona bien en navegadores móviles.",

  "pricing.title": "Precios Simples y Transparentes",
  "pricing.subtitle": "Elige el plan perfecto para tus necesidades creativas",
  "pricing.monthly": "Mensual",
  "pricing.yearly": "Anual",
  "pricing.save17": "Ahorra 17%",
  "pricing.popular": "MÁS POPULAR",
  "pricing.guarantee": "Garantía de Devolución de 30 Días",
  "pricing.loginPrompt": "Por favor inicia sesión primero para actualizar a Pro",
  "pricing.free.name": "Gratis",
  "pricing.free.desc": "Perfecto para probar la generación de imágenes IA",
  "pricing.free.cta": "Empezar Gratis",
  "pricing.free.f1": "10 imágenes por día",
  "pricing.free.f2": "Calidad estándar (512x512)",
  "pricing.free.f3": "Estilos y filtros básicos",
  "pricing.free.f4": "Soporte comunitario",
  "pricing.free.f5": "Imágenes con marca de agua",
  "pricing.free.f6": "Velocidad de generación estándar",
  "pricing.pro.name": "Pro",
  "pricing.pro.desc": "Para profesionales y creadores de contenido",
  "pricing.pro.cta": "Actualizar a Pro",
  "pricing.pro.f1": "Imágenes ilimitadas",
  "pricing.pro.f2": "Alta calidad (1024x1024)",
  "pricing.pro.f3": "Estilos y filtros premium",
  "pricing.pro.f4": "Soporte prioritario",
  "pricing.pro.f5": "Sin marcas de agua",
  "pricing.pro.f6": "Velocidad de generación rápida",
  "pricing.pro.f7": "Generación en lote (hasta 10)",
  "pricing.pro.f8": "Licencia comercial",
  "pricing.pro.f9": "Modelos IA avanzados",
  "pricing.pro.f10": "Ampliación de imágenes",
  "pricing.pro.saveYear": "Ahorra $30/año",
  "pricing.paypalCheckout": "Completa tu suscripción a través de PayPal",
  "pricing.cancelPayment": "Cancelar",
  "pricing.subscriptionSuccess": "¡Suscripción exitosa! ¡Bienvenido a Pro!",

  "compare.title": "Comparación Detallada",
  "compare.subtitle": "Ve qué está incluido en cada plan",
  "compare.feature": "Característica",
  "compare.free": "Gratis",
  "compare.pro": "Pro",
  "compare.f1": "Generaciones de Imágenes",
  "compare.v1.free": "Ilimitado",
  "compare.v1.pro": "Ilimitado",
  "compare.f2": "Resolución Máxima",
  "compare.v2.free": "1024x1024",
  "compare.v2.pro": "4096x4096",
  "compare.f3": "Velocidad de Generación",
  "compare.v3.free": "Estándar",
  "compare.v3.pro": "3x Más Rápido",
  "compare.f4": "Generación en Lote",
  "compare.v4.free": "5 imágenes",
  "compare.v4.pro": "20 imágenes",
  "compare.f5": "Opciones de Estilo",
  "compare.v5.free": "Básico",
  "compare.v5.pro": "Avanzado",
  "compare.f6": "Herramientas de Edición",
  "compare.v6.free": "Básico",
  "compare.v6.pro": "Avanzado",
  "compare.f7": "Anuncios",
  "compare.v7.free": "Sí",
  "compare.v7.pro": "No",
  "compare.f8": "Soporte Prioritario",
  "compare.v8.free": "No",
  "compare.v8.pro": "Sí",
  "compare.f9": "Licencia Comercial",
  "compare.v9.free": "Sí",
  "compare.v9.pro": "Sí",
  "compare.f10": "Marca de Agua",
  "compare.v10.free": "No",
  "compare.v10.pro": "No",

  "gen.title": "Generador de Imágenes IA",
  "gen.subtitle": "Crea imágenes impresionantes con IA - Gratis, ilimitado, sin registro",
  "gen.mode": "Modo de Generación",
  "gen.textToImage": "Texto a Imagen",
  "gen.imageToImage": "Imagen a Imagen",
  "gen.aspectRatio": "Relación de Aspecto",
  "gen.style": "Estilo",
  "gen.style.none": "Sin Estilo",
  "gen.style.realistic": "Realista",
  "gen.style.anime": "Anime",
  "gen.style.artistic": "Artístico",
  "gen.style.digital": "Arte Digital",
  "gen.promptLabel": "Describe lo que quieres crear",
  "gen.promptPlaceholder": "Un hermoso atardecer sobre montañas con colores vibrantes...",
  "gen.promptTip": "💡 Consejo: Sé específico y descriptivo para mejores resultados",
  "gen.uploadLabel": "Subir Imagen Fuente",
  "gen.uploadHint": "Haz clic para subir o arrastra y suelta",
  "gen.uploadSize": "PNG, JPG hasta 10MB",
  "gen.generateBtn": "Generar Imagen",
  "gen.free": "Gratis",
  "gen.resultPlaceholder": "Tu imagen generada aparecerá aquí",
  "gen.emptyPrompt": "Por favor ingresa un prompt para generar una imagen",
  "gen.promptPrefilled": "✨ ¡Prompt cargado desde la galería! Haz clic en Generar para crear tu imagen.",
  "gen.clearPrompt": "Limpiar",

  // Pestañas del generador y nuevas claves
  "gen.tabSingle": "Imagen Única",
  "gen.tabBatch": "Generación en Lote",
  "gen.tabHistory": "Historial",
  "gen.successMsg": "¡Imagen generada con éxito!",
  "gen.generating": "Generando...",
  "gen.download": "Descargar Imagen",
  "gen.new": "Nuevo",

  // Historial de imágenes
  "history.title": "Historial de Generación",
  "history.empty": "Aún no se han generado imágenes",
  "history.emptyHint": "Tus imágenes generadas aparecerán aquí",
  "history.clearAll": "Borrar Todo",
  "history.clearConfirmTitle": "¿Borrar todo el historial?",
  "history.clearConfirmDesc": "Esto eliminará permanentemente todo tu historial de generación. Esta acción no se puede deshacer.",
  "history.cancel": "Cancelar",
  "history.clearConfirm": "Borrar Todo",
  "history.reuse": "Usar Este Prompt",
  "history.download": "Descargar",
  "history.copyPrompt": "Copiar Prompt",
  "history.justNow": "Ahora mismo",
  "history.minutesAgo": "hace {{count}}m",
  "history.hoursAgo": "hace {{count}}h",
  "history.daysAgo": "hace {{count}}d",

  // Generación en lote
  "batch.title": "Generación en Lote",
  "batch.badge": "Función Pro",
  "batch.countLabel": "Número de imágenes a generar",
  "batch.images": "imágenes",
  "batch.generateBtn": "Generar {{count}} Imágenes",
  "batch.generating": "Generando",
  "batch.progressText": "{{done}} de {{total}} imágenes completadas",
  "batch.results": "Imágenes Generadas",
  "batch.downloadAll": "Descargar Todo",
  "batch.hint": "Ingresa un prompt a la izquierda, luego genera múltiples variaciones a la vez",

  // Imagen a Video
  "gen.tabI2V": "Imagen a Video",
  "i2v.title": "Imagen a Video",
  "i2v.uploadTitle": "Sube o pega una imagen",
  "i2v.uploadHint": "Haz clic para subir, arrastra o Ctrl+V para pegar",
  "i2v.uploadFormats": "PNG, JPG, WebP hasta 20MB",
  "i2v.changeImage": "Cambiar",
  "i2v.effectLabel": "Efecto de Movimiento",
  "i2v.effectZoomIn": "Acercar",
  "i2v.effectZoomOut": "Alejar",
  "i2v.effectPanLeft": "Izquierda",
  "i2v.effectPanRight": "Derecha",
  "i2v.effectPanUp": "Arriba",
  "i2v.generateBtn": "Generar Video",
  "i2v.generating": "Generando",
  "i2v.progressHint": "Renderizando fotogramas, por favor espera...",
  "i2v.success": "¡Video generado con éxito!",
  "i2v.download": "Descargar Video",
  "i2v.regenerate": "Intentar de Nuevo",
  "i2v.error": "Error al generar el video. Inténtalo de nuevo.",
  "i2v.invalidFile": "Selecciona un archivo de imagen válido.",
  "i2v.fileTooLarge": "El archivo es demasiado grande. Máximo 20MB.",

  "footer.stayUpdated": "Mantente Actualizado",
  "footer.newsletter": "Obtén las últimas actualizaciones sobre nuevas funciones y consejos",
  "footer.emailPlaceholder": "Tu dirección de correo electrónico",
  "footer.subscribe": "Suscribirse",
  "footer.product": "Producto",
  "footer.features": "Características",
  "footer.company": "Empresa",
  "footer.legal": "Legal",
  "footer.aiGenerator": "Generador IA",
  "footer.pricing": "Precios",
  "footer.textToImage": "Texto a Imagen",
  "footer.imageToImage": "Imagen a Imagen",
  "footer.styleTransfer": "Transferencia de Estilo",
  "footer.aboutUs": "Sobre Nosotros",
  "footer.contact": "Contacto",
  "footer.privacy": "Política de Privacidad",
  "footer.terms": "Términos de Servicio",
  "footer.copyright": "© 2025 AI Image Generator. Todos los derechos reservados.",
  "footer.poweredBy": "Powered by Readdy",

  // Pro Banner
  "proBanner.badge": "OFERTA POR TIEMPO LIMITADO",
  "proBanner.title": "Desbloquea Pro para el Máximo Poder Creativo",
  "proBanner.subtitle": "Obtén resolución 4K, generación 3x más rápida, procesamiento por lotes y sin anuncios.",
  "proBanner.f1": "3x Más Rápido",
  "proBanner.f2": "Resolución 4K",
  "proBanner.f3": "Generación en Lote",
  "proBanner.f4": "Sin Anuncios",
  "proBanner.discount": "Ahorra 48% — Tiempo Limitado",
  "proBanner.cta": "Actualizar a Pro Ahora",
  "proBanner.guarantee": "Garantía de devolución de 30 días",

  // Member Center
  "member.loginRequired": "Inicio de Sesión Requerido",
  "member.loginDesc": "Por favor inicia sesión para acceder a tu Centro de Miembros y gestionar tu suscripción.",
  "member.backHome": "Volver al Inicio",
  "member.freePlan": "Plan Gratis",
  "member.proPlan": "Plan Pro",
  "member.currentPlan": "Plan Actual",
  "member.planType": "Tipo de Plan",
  "member.freePlanLabel": "Gratis",
  "member.resolution": "Resolución Máxima",
  "member.speed": "Velocidad de Generación",
  "member.speedStandard": "Estándar",
  "member.speed3x": "3x Más Rápido",
  "member.batch": "Generación en Lote",
  "member.batch5": "Hasta 5",
  "member.batch20": "Hasta 20",
  "member.watermark": "Marca de Agua",
  "member.noWatermark": "Sin Marca de Agua",
  "member.hasWatermark": "Sí",
  "member.usageStats": "Estadísticas de Uso",
  "member.todayUsage": "Uso de Hoy",
  "member.totalGenerated": "Total Generado",
  "member.memberSince": "Miembro Desde",
  "member.upgradeTitle": "Actualiza a Pro para la Experiencia Completa",
  "member.upgradeDesc": "Desbloquea resolución 4K, velocidad 3x, generación en lote, sin marcas de agua y sin anuncios.",
  "member.upgradeCta": "Actualizar a Pro",
  "member.proBenefits": "Tus Beneficios Pro",
  "member.benefit1": "Imágenes Ilimitadas",
  "member.benefit2": "Resolución 4K",
  "member.benefit3": "Velocidad 3x",
  "member.benefit4": "Generación en Lote",
  "member.benefit5": "Sin Anuncios",
  "member.benefit6": "Licencia Comercial",
};

export default common;
